import React from 'react';
import { useTheme } from '../../../../contexts/ThemeContext';

const ViewTypeArticleModal = ({ isOpen, typeArticle, onClose }) => {
  const { isDarkMode } = useTheme();

  if (!isOpen || !typeArticle) return null;

  const getFamilleInfo = (familleId) => {
    const familleData = {
      1: {
        name: 'Extincteurs',
        icon: 'fas fa-fire-extinguisher'
      },
      2: {
        name: "Types d'extinction",
        icon: 'fas fa-spray-can'
      },
      3: {
        name: 'Équipements',
        icon: 'fas fa-tools'
      }
    };
    return familleData[familleId] || familleData[1];
  };

  const familleInfo = getFamilleInfo(typeArticle.familleId);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className={`rounded-2xl shadow-2xl w-full max-w-3xl max-h-[95vh] overflow-hidden ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
        {/* Header */}
        <div className={`px-6 py-6 ${isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-r from-primary-600 to-primary-700'}`}>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-2xl flex items-center justify-center mr-4">
                <i className={`${familleInfo.icon} text-white text-2xl`}></i>
              </div>
              <div>
                <h2 className="text-2xl font-bold text-white">{typeArticle.designation}</h2>
                <div className="flex items-center space-x-4 mt-1">
                  <p className="text-primary-100 flex items-center">
                    <i className="fas fa-hashtag mr-1 text-sm"></i>
                    ID: {typeArticle.id}
                  </p>
                  <div className="px-3 py-1 bg-white bg-opacity-20 rounded-full">
                    <span className="text-primary-100 text-sm">
                      {familleInfo.name}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:bg-white hover:bg-opacity-20 rounded-xl p-2 transition-colors"
            >
              <i className="fas fa-times text-xl"></i>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="overflow-y-auto max-h-[calc(95vh-120px)] p-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Left Column - Basic Information */}
            <div className="space-y-6">
              {/* Main Info Card */}
              <div className={`rounded-2xl p-6 border ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'}`}>
                <h3 className={`text-lg font-semibold mb-4 flex items-center ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                  <i className={`${familleInfo.icon} mr-2 ${isDarkMode ? 'text-gray-400' : 'text-primary-600'}`}></i>
                  Informations principales
                </h3>
                
                <div className="space-y-4">
                  <div className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg p-4 shadow-sm`}>
                    <div className="flex items-center justify-between">
                      <div>
                        <p className={`text-xs uppercase tracking-wide font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Désignation</p>
                        <p className={`text-xl font-bold mt-1 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{typeArticle.designation}</p>
                      </div>
                      <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${isDarkMode ? 'bg-gray-700 text-gray-200 border-gray-600' : 'bg-gray-100 text-gray-800 border-gray-200'}`}>
                        <i className={`${familleInfo.icon} text-lg`}></i>
                      </div>
                    </div>
                  </div>

                  <div className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg p-4 shadow-sm`}>
                    <div className="flex items-center justify-between">
                      <div>
                        <p className={`text-xs uppercase tracking-wide font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Famille</p>
                        <p className={`text-lg font-semibold mt-1 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{familleInfo.name}</p>
                        <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>ID: {typeArticle.familleId}</p>
                      </div>
                      <div className={`px-3 py-2 rounded-full text-sm font-semibold ${isDarkMode ? 'bg-gray-700 text-gray-200 border-gray-600' : 'bg-gray-100 text-gray-800 border-gray-200'}`}>
                        Famille {typeArticle.familleId}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Additional Info */}
            <div className="space-y-6">
              {/* Family Details */}
              <div className={`rounded-2xl p-6 border ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'}`}>
                <h3 className={`text-lg font-semibold mb-4 flex items-center ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                  <i className={`fas fa-sitemap mr-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}></i>
                  Détails de la famille
                </h3>
                
                <div className="space-y-4">
                  <div className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg p-4 shadow-sm`}>
                    <h4 className={`font-semibold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{familleInfo.name}</h4>
                    <p className={`text-sm mb-3 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                      {typeArticle.familleId === 1 && "Famille regroupant tous les types d'extincteurs et leurs caractéristiques."}
                      {typeArticle.familleId === 2 && "Famille regroupant les différents types d'agents extincteurs utilisés."}
                      {typeArticle.familleId === 3 && "Famille regroupant les équipements et accessoires de sécurité incendie."}
                    </p>
                    <div className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${isDarkMode ? 'bg-gray-700 text-gray-200 border-gray-600' : 'bg-gray-100 text-gray-800 border-gray-200'}`}>
                      <div className="w-2 h-2 rounded-full bg-current mr-2"></div>
                      Famille {typeArticle.familleId}
                    </div>
                  </div>
                </div>
              </div>

              {/* Recent Activity */}
              <div className={`rounded-2xl p-6 border ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'}`}>
                <h3 className={`text-lg font-semibold mb-4 flex items-center ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                  <i className={`fas fa-clock mr-2 ${isDarkMode ? 'text-gray-400' : 'text-amber-600'}`}></i>
                  Activité récente
                </h3>
                
                <div className="space-y-3">
                  <div className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} flex items-center p-3 rounded-lg shadow-sm`}>
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-3 ${isDarkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-100 text-green-600'}`}>
                      <i className="fas fa-plus text-xs"></i>
                    </div>
                    <div className="flex-1">
                      <p className={`text-sm font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Type créé</p>
                      <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Il y a 2 jours</p>
                    </div>
                  </div>
                  
                  <div className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} flex items-center p-3 rounded-lg shadow-sm`}>
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-3 ${isDarkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-100 text-blue-600'}`}>
                      <i className="fas fa-eye text-xs"></i>
                    </div>
                    <div className="flex-1">
                      <p className={`text-sm font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Dernière consultation</p>
                      <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Il y a 1 heure</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Footer */}
        <div className={`px-6 py-4 border-t ${isDarkMode ? 'border-gray-700 bg-gray-750' : 'bg-gray-50 border-gray-200'}`}>
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className={`px-6 py-3 rounded-lg transition-colors font-medium ${
                isDarkMode
                  ? 'bg-gray-600 text-white hover:bg-gray-700'
                  : 'bg-primary-600 text-white hover:bg-primary-700'
              }`}
            >
              <i className="fas fa-check mr-2"></i>
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewTypeArticleModal;